


































import { height } from 'dom7';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class GmailColorful extends Vue {
  @Prop({ default: '20' }) readonly width?: string;
  @Prop({ default: '20' }) readonly height?: string;
}
